import { render, staticRenderFns } from "./SmartChurchLayout.vue?vue&type=template&id=3cd974d0&scoped=true&"
import script from "./SmartChurchLayout.vue?vue&type=script&lang=js&"
export * from "./SmartChurchLayout.vue?vue&type=script&lang=js&"
import style0 from "./SmartChurchLayout.vue?vue&type=style&index=0&id=3cd974d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd974d0",
  null
  
)

export default component.exports